import React, { FC } from 'react';
import { AppVersion } from '../types/enums';
import { AppConfig } from '../config/AppConfig';
import dsmLogo from '../assets/dsmAssets/dsmLogo.png';

interface PlaceholderOverlayProps {
    version: AppVersion;
    style?: React.CSSProperties;
}

export const PlaceholderOverlay: FC<PlaceholderOverlayProps> = ({ version, style }) => {
    const theme = AppConfig.theme[version];

    const renderContent = () => {
        switch (version) {
            case AppVersion.DSM:
                return <img src={dsmLogo} alt="DSM Logo" style={{ maxWidth: '200px', height: 'auto' }} />;
            case AppVersion.LTM: 
                return <h1>Accenture</h1>;
            default:
                return <h1>AR viewer</h1>;
        }
    };

    return (
        <div
            className="accenture-placeholder"
            style={{
                position: "absolute",
                top: '-9%',
                backgroundColor: theme.backgroundColor,
                color: theme.fontColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                ...style
            }}
        >
            {renderContent()}
        </div>
    );
};
